import { useState } from "react";
import { HelpCircle } from "lucide-react";

/**
 * Tiny inline "?" affordance that reveals a short explanation on hover / tap.
 * Great for glossary terms (BAC, IU, subQ, titration, half-life).
 *
 * <InfoTip text="Bacteriostatic water — sterile water with 0.9% benzyl alcohol used for reconstitution." />
 */
export default function InfoTip({ text, className = "" }) {
  const [open, setOpen] = useState(false);
  return (
    <span className={`relative inline-flex items-center ${className}`}>
      <button
        type="button"
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        onFocus={() => setOpen(true)}
        onBlur={() => setOpen(false)}
        onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
        className="text-[color:var(--text-muted)] hover:text-[color:var(--brand)] transition-colors"
        aria-label="More info"
        data-testid="infotip-trigger"
      >
        <HelpCircle className="w-3.5 h-3.5" />
      </button>
      {open && (
        <span
          className="absolute z-50 bottom-full left-1/2 -translate-x-1/2 mb-2 px-3 py-2 min-w-[220px] max-w-[280px] bg-slate-900 border border-[#0D9488] text-xs text-white leading-relaxed pointer-events-none shadow-lg"
          data-testid="infotip-content"
        >
          {text}
        </span>
      )}
    </span>
  );
}
